const form = {
    inputHeightBase: 46,
    borderRadius: 5,
    formWrapperWidth: 310,
};

export default form;
